// Keep navigation/reload behind actual composer persistence. Every listener
// adds its own promise; a rejection or timeout leaves the current work intact.
export async function flushAttentionDrafts({ purpose = 'navigate', timeout = 2500 } = {}) {
  const detail = { failed: false, pending: [], purpose };
  window.dispatchEvent(new CustomEvent('attention:save-draft', { detail }));
  if (detail.failed) return false;
  let timer;
  try {
    const results = await Promise.race([
      Promise.allSettled(detail.pending),
      new Promise(resolve => { timer = setTimeout(() => resolve(null), timeout); }),
    ]);
    return !detail.failed && !!results && results.every(result => result.status === 'fulfilled');
  } finally { clearTimeout(timer); }
}
